<template>
    <div class="header">
        <div class="wrap">
            <div class="logo fl">
                <img src="http://www.evhui.com/wp-content/themes/evhui3.0/public/images/logo.png" alt="电车汇">
            </div>
            <ul class="nav fl">
                <li><a href="http://www.evhui.com/">首页</a></li>
                <li>
                    <a href="javascript:void(0);" style="line-height: 100px; transition: all 0.4s ease;">分类</a><span></span>
                    <ul style="top: 100px; transition: all 0.4s ease;">
                        <li onclick="window.location.href='http://www.evhui.com/category/info'"><em class="icon_info_small fl"></em>讯息</li>
                        <li onclick="window.location.href='http://www.evhui.com/category/voice'"><em class="icon_voice_small fl"></em>声音
                        </li>
                        <li onclick="window.location.href='http://www.evhui.com/category/newdeal'"><em class="icon_newdeal_small fl"></em>新政
                        </li>
                        <li onclick="window.location.href='http://www.evhui.com/category/industry'"><em class="icon_industry_small fl"></em>产业
                        </li>
                        <li onclick="window.location.href='http://www.evhui.com/category/evaluating'"><em class="icon_evaluating_small fl"></em>评测
                        </li>
                    </ul>
                </li>
                <li><a href="http://car.evhui.com/">电车库</a></li>
                <li>
                    <a href="javascript:void(0);" style="line-height: 100px; transition: all 0.4s ease;">资源</a><span></span>
                    <ul class="nav2_long" style="top: 100px; transition: all 0.4s ease;">
                        <li onclick="window.location.href='http://www.evhui.com/policy'"><em class="icon_file_small fl"></em>政策规划库</li>
                        <li onclick="window.location.href='http://www.evhui.com/standard'"><em class="icon_standard_small fl"></em>行业标准库</li>
                        <li onclick="window.location.href='http://www.evhui.com/reportlist'"><em class="icon_report_small fl"></em>数据图表报告</li>
                        <li onclick="window.location.href='http://tool.evhui.com/hotlist'"><em class="icon_subsidies_small fl"></em>补贴免税查询</li>
                        <li onclick="window.location.href='http://tool.evhui.com/'"><em class="icon_subsidies_small fl"></em>产销数据查询</li>
                    </ul>
                </li>
                <li><a href="http://list.qq.com/cgi-bin/qf_invite?id=1b75588466e4e916a9db719ea41bdde3c3a718745a158c52">订阅</a></li>
            </ul>
            <div class="fr-wrap fr">
                <div class="search fl">
                    <img src="http://www.evhui.com/wp-content/themes/evhui3.0/public/images/search.jpg" width="40" height="40" class="fr" alt="">
                    <input type="text" class="search-txt fr" placeholder="请输入搜索内容……">
                </div>
                <div class="btn-wrap" id="unlogin" v-if="!isLogin">
                    <button class="fl" @click="showObj.login=true">登录</button>
                    <button class="fl" @click="showObj.register=true">注册</button>
                </div>
                <div class="info-wrap" id="islogin" v-if="isLogin">
                    <div class="my-info">
                        <img src="http://www.evhui.com/wp-content/themes/evhui3.0/public/images/nophoto.jpg" alt="">
                        <ul>
                            <li class="logout" @click="logout()">
                                <span></span>
                                <a href="javascript:;">退出登录</a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <Register :showObj="showObj"></Register>
        <Login :showObj="showObj" v-on:userLogin="judgeLogin"></Login>
        <Changepwd :showObj="showObj"></Changepwd>
        <Qrcode :showObj="showObj"></Qrcode>
    </div>
</template>

<script>
    import Register from './modal/Register'
    import Login from './modal/Login'
    import Changepwd from './modal/Changepwd'
    import Qrcode from './modal/Qrcode'
    import vue from 'vue'

    export default {
        components: {
            Register,
            Login,
            Changepwd,
            Qrcode
        },
        props: ['isLogin'],
        data() {
            return {
                showObj: {
                    register: false,
                    login: false,
                    changePwd: false,
                    qrcode: false
                }
            }
        },
        mounted() {
            // console.log(this);
            // this.$nextTick(function () {
            //     this.judgeLogin();
            // });
        },
        methods: {
            judgeLogin: function() {
                var that = this;
                var jwt_token  = this.cookie('get', 'jwt_token');
                if(jwt_token) {
                    that.isLogin = true;
                }else {
                    that.isLogin = false;
                }
            },
            cookie: function(type, c_name, value, expiredays) {
                if(type === 'set') {
                    var exdate=new Date()
                    exdate.setDate(exdate.getDate()+expiredays)
                    document.cookie=c_name+ "=" +escape(value)+
                    ((expiredays==null) ? "" : "; expires="+exdate.toGMTString())
                }else if(type === 'get') {
                    if (document.cookie.length > 0) {
                        var c_start = document.cookie.indexOf(c_name + "=")
                        if (c_start != -1) {
                            c_start = c_start + c_name.length + 1
                            var c_end = document.cookie.indexOf(";", c_start)
                            if (c_end == -1) c_end = document.cookie.length
                            return unescape(document.cookie.substring(c_start, c_end))
                        }
                    }
                    return;
                }
            },
            logout: function() {
                vue.auth.logout();
            }
        }
    }
</script>

<style lang="scss" scoped>
    $maincolor: #0666b2;
    .fl {
        float: left;
    }
    .fr {
        float: right;
    }
    .wrap {
        width: 1030px;
        margin: 0 auto;
    }
    .header {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100px;
        background-color: #293A53;
        z-index: 1000;
    }
    .logo img {
        margin-top: 5px;
    }
    .nav {
        width: 465px;
        height: 100%;
        padding-left: 50px;
        li {
            position: relative;
            float: left;
            height: 100%;
            padding: 0 15px;
            &:hover {
                background: #0666B2;
                transition: all 0.2s ease;
                span {
                    border-width: 5px 5px 0 5px;
                    border-color: #fff #0666B2 transparent #0666B2;
                    border-style: solid solid none solid;
                }
                >ul {
                    display: block;
                }
            }
            a {
                padding: 0 10px;
                line-height: 100px;
                color: #fff;
            }
            ul {
                position: absolute;
                top: 100px;
                left: 0;
                display: none;
                z-index: 101;
                li {
                    position: relative;
                    float: left;
                    height: 40px;
                    padding: 10px 24px 0 0;
                    text-align: center;
                    background: rgba(6,102,178,0.9);
                    border-bottom: 1px solid #578EC2;
                    color: #fff;
                    font-size: 14px;
                    cursor: pointer;
                    line-height: 30px;
                    &:hover {
                        background: rgba(41,58,83,0.9);
                    }
                }
                em {
                    width: 16px;
                    height: 16px;
                    margin: 9px 4px 0 20px;
                    background: url(http://www.evhui.com/wp-content/themes/evhui3.0/public/images/icon.png) no-repeat;
                }
                .icon_info_small {
                    background-position: -435px -716px;
                }
                .icon_voice_small {
                    background-position: -435px -757px;
                }
                .icon_newdeal_small {
                    background-position: -435px -798px;
                }
                .icon_industry_small {
                    background-position: -435px -837px;
                }
                .icon_evaluating_small {
                    background-position: -435px -877px;
                }
                .icon_file_small {
                    background-position: -460px -716px;
                }
                .icon_standard_small {
                    background-position: -460px -757px;
                }
                .icon_report_small {
                    background-position: -460px -798px;
                }
                .icon_subsidies_small {
                    background-position: -432px -915px;
                }
            }
            .nav2_long li {
                width: 150px;
            }
            span {
                display: inline-block;
                width: 0;
                height: 0;
                border-width: 5px 5px 0 5px;
                border-color: #fff #293A53 transparent #293A53;
                border-style: solid solid none solid;
            }
        }
    }
    .fr-wrap {
        width: 420px;
        height: 100px;
        display: table-cell;
        vertical-align: middle;
        .search {
            width: 230px;
            margin: 30px 13px 0 0;
            &:hover {
                .search-txt {
                    display: inline-block;
                }
            }
            img {
                cursor: pointer;
            }
        }
        .search-txt {
            display: inline-block;
            width: 170px;
            background: #f2f2f2;
            border-radius: 3px;
            border-top-right-radius: 0;
            border-bottom-right-radius: 0;
            padding-left: 10px;
            cursor: auto;
            color: #333;
            font-size: 14px;
            display: none;
            height: 40px;
            margin: 0px 0px 0px 8px;
            box-shadow: 0 2px 0 #20293B;
            border: none;
            box-sizing: border-box;
        }
        button {
            width: 80px;
            height: 40px;
            margin: 30px 0px 0px 8px;
            font: normal 16px/40px Helvetica,Microsoft Yahei;
            background: #0765B0;
            border-radius: 2px;
            color: #fff;
            cursor: pointer;
            box-shadow: 0 2px 0 #20293B;
            border: none;
            box-sizing: border-box;
            &:hover {
                background: #0196C9;
            }
        }
    }
    .my-info {
        position: relative;
        float: right;
        width: 60px;
        height: 100px;
        transition: all 0.4s ease;
        &:hover {
            background-color: $maincolor;
            ul {
                display: block;
            }
        }
        img {
            width: 32px;
            margin-top: 35px;
            margin-left: 14px;
        }
        ul {
            display: none;
            position: absolute;
            top: 100px;
            right: 0;
            width: 130px;
            transition: all 0.4s ease;
            li {
                height: 50px;
                padding: 0 15px;
                background: rgba(6,102,178,0.9);
                border-bottom: 1px solid #578EC2;
                color: #fff;
                cursor: pointer;
            }
            a {
                line-height: 50px;
                font-size: 14px;
                color: #fff;
            }
            .logout {
                border-bottom: none;
                &:hover {
                    background: rgba(237,89,89,0.9);
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// Header.vue?2ee4a924